function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import concat from 'ramda/src/concat';
import find from 'ramda/src/find';
import path from 'ramda/src/path';
import pathOr from 'ramda/src/pathOr';
import propEq from 'ramda/src/propEq';
import toPairs from 'ramda/src/toPairs';
import values from 'ramda/src/values';
import { createSelector } from 'reselect';
import moment from 'moment';
import i18n from 'invision-core/src/components/i18n/i18n';
import { MetadataCodeSelector, MetadataCodeLoadedSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import CustomerLocaleKeys from '../../locales/keys';
import { RouteParams, RoutePreviousState, SelectedCustomerSelector } from './customer.selectors';
export var GLYPH = {
  ARCHIVE: 'archive',
  CLOCK_O: 'clock-o',
  NET_LINK: 'net_link',
  SEARCH: 'search'
};
var RecoverableContentActivitySelector = function RecoverableContentActivitySelector(state) {
  return pathOr(null, ['customercare', 'recoverableUiState', 'contentActivity'], state);
};
export var SelectedItemIdSelector = createSelector([RecoverableContentActivitySelector], function (uiState) {
  return uiState.selectedItemId;
});
export var ProductIdRouteParamSelector = createSelector([RouteParams], function (routeParams) {
  return routeParams.productId;
});
export var DeviceIdRouteParamSelector = createSelector([RouteParams], function (routeParams) {
  return routeParams.deviceId;
});
export var DeviceNameRouteParamSelector = createSelector([RouteParams], function (routeParams) {
  return routeParams.deviceName;
});
export var DeviceFilterTextSelector = createSelector([DeviceNameRouteParamSelector], function (deviceName) {
  var deviceNameDisplayText = deviceName || null;
  return i18n.translate(CustomerLocaleKeys.CONTENT_ACTIVITY.FILTER.DEVICE_NAME, {
    deviceNameDisplayText: deviceNameDisplayText
  });
});
export var ActiveIsSelectedSelector = createSelector([RecoverableContentActivitySelector], function (uiState) {
  return pathOr(null, ['filterData', 'activeIsSelected'], uiState);
});
export var CurrentPageSelector = createSelector([RecoverableContentActivitySelector], function (uiState) {
  return pathOr(null, ['filterData', 'currentPage'], uiState);
});
export var SelectedPageSizePreference = createSelector([RecoverableContentActivitySelector], function (uiState) {
  return pathOr(null, ['filterData', 'pageSizePreference'], uiState);
});
export var CustomerContentActivitySelector = createSelector([ProductIdRouteParamSelector, DeviceIdRouteParamSelector, SelectedCustomerSelector], function (productId, deviceId, selectedCustomer) {
  var contentActivity = pathOr(null, ['contentActivity', 'data'], selectedCustomer);

  // The API doesn't filter the active list when a productId or deviceId is present so we are doing it here
  if (contentActivity && contentActivity.active && (productId || deviceId)) {
    var filteredActive = {};
    toPairs(contentActivity.active).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
      if (value.ProductId && value.ProductId.toString() === productId || value.PhysicalDeviceId && value.PhysicalDeviceId.toString() === deviceId) {
        filteredActive[key] = value;
      }
    });
    return contentActivity.set('active', filteredActive);
  }
  return contentActivity;
});
export var HasActiveContentActivitySelector = createSelector([CustomerContentActivitySelector], function (contentActivity) {
  return contentActivity ? !!Object.keys(contentActivity.active).length : false;
});
export var HasLoadedContentActivitySelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return pathOr(false, ['contentActivity', 'hasBeenLoaded'], selectedCustomer);
});
export var IsFetchingContentActivitySelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return pathOr(false, ['contentActivity', 'isLoadingContentActivity'], selectedCustomer);
});
export var IsLoadingDetails = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return pathOr(false, ['contentActivity', 'isLoadingContentActivityDetails'], selectedCustomer);
});
export var ActiveItemCountSelector = createSelector([CustomerContentActivitySelector], function (contentActivity) {
  return contentActivity && contentActivity.active ? values(contentActivity.active).length : 0;
});
var EMPTY_CONTENT_ACTIVITY_COLLECTION = [];
export var CustomerContentActivityCollectionSelector = createSelector([CustomerContentActivitySelector, ActiveIsSelectedSelector, MetadataCodeSelector(CODES.ProductLineOfBusinessDeliveryCapability), MetadataCodeLoadedSelector(CODES.ProductLineOfBusinessDeliveryCapability)], function (contentActivity, activeIsSelected, productLOBDeliveryCapability, hasProductLOBDeliveryCapabilityLoaded) {
  if (!contentActivity || !hasProductLOBDeliveryCapabilityLoaded) {
    return EMPTY_CONTENT_ACTIVITY_COLLECTION;
  }
  var selectedActivityList;
  if (activeIsSelected) {
    selectedActivityList = contentActivity.active ? values(contentActivity.active) : null;
  } else {
    selectedActivityList = contentActivity.archived ? values(contentActivity.archived) : null;
  }
  return selectedActivityList.map(function (item) {
    var associatedCapability = productLOBDeliveryCapability.items.find(function (capability) {
      return item.DeliveryCapability && item.DeliveryCapability.toString() === capability.Value;
    });
    var durationString;
    var difference;
    if (item.Ended) {
      difference = moment(item.Ended).diff(moment(item.Added));
    } else {
      difference = moment().diff(moment(item.Added));
    }
    var duration = difference > 0 ? moment.duration(difference) : moment.duration(moment());
    var H = i18n.translate(CustomerLocaleKeys.CONTENT_ACTIVITY.DURATION.UNITS.HOUR);
    var M = i18n.translate(CustomerLocaleKeys.CONTENT_ACTIVITY.DURATION.UNITS.MINUTE);
    var hours = duration.hours();
    var minutes = duration.minutes();
    if (hours > 0) {
      durationString = "".concat(hours).concat(H, " ").concat(minutes).concat(M);
    } else if (minutes > 0) {
      durationString = "".concat(minutes).concat(M);
    } else {
      durationString = "<1".concat(M);
    }
    //A neutral delivery capability code will be 0 which doesn't have
    //a lookup in productLOBDeliveryCapability(20)
    if (associatedCapability) {
      item = item.set('DeliveryCapabilityName', associatedCapability.Name);
    }
    item = item.set('duration', durationString);
    return item;
  });
});
export var SelectedProductSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return pathOr(null, ['contentActivity', 'selectedProduct'], selectedCustomer);
});
export var SelectedActivitySelector = createSelector([SelectedItemIdSelector, CustomerContentActivityCollectionSelector, SelectedProductSelector], function (selectedItemId, collection, selectedProduct) {
  var selectedCollectionItem = null;
  if (!selectedItemId && collection.length) {
    selectedCollectionItem = collection[0];
  } else if (collection.length > 0) {
    selectedCollectionItem = find(propEq(selectedItemId, 'Id'))(collection);
  }
  if (selectedCollectionItem && selectedProduct && selectedProduct.PricingPlans && selectedProduct.PricingPlans.length) {
    var pricingPlan = selectedProduct.PricingPlans.find(function (plan) {
      return plan.Id === selectedCollectionItem.PricingPlanId;
    });
    selectedCollectionItem = Object.assign({}, selectedCollectionItem, {
      pricingPlanName: pricingPlan ? pricingPlan.Name : ''
    });
  }
  return selectedCollectionItem;
});
export var AllContentActivityCollectionSelector = createSelector([CustomerContentActivitySelector], function (contentActivity) {
  if (contentActivity) {
    var completeList = [];
    completeList = concat(completeList, values(contentActivity.active));
    completeList = concat(completeList, values(contentActivity.archived));
    return completeList;
  }
  return EMPTY_CONTENT_ACTIVITY_COLLECTION;
});
export var ActiveContentCollectionSelector = createSelector([CustomerContentActivitySelector], function (contentActivity) {
  if (contentActivity) {
    return values(contentActivity.active.asMutable({
      deep: true
    }));
  }
  return EMPTY_CONTENT_ACTIVITY_COLLECTION;
});
export var ProductNameSelector = createSelector([SelectedProductSelector, ProductIdRouteParamSelector], function (selectedProduct, productId) {
  return selectedProduct && selectedProduct.Id.toString() === productId ? selectedProduct.Name : null;
});
export var ProductFilterTextSelector = createSelector([ProductNameSelector], function (productName) {
  var productNameDisplayText = productName || i18n.translate(CustomerLocaleKeys.CONTENT_ACTIVITY.PRODUCT.NOT_FOUND);
  return i18n.translate(CustomerLocaleKeys.CONTENT_ACTIVITY.FILTER.PRODUCT_NAME, {
    productNameDisplayText: productNameDisplayText
  });
});
export var IsLoadingProductSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return pathOr(false, ['contentActivity', 'isLoadingProduct'], selectedCustomer);
});
export var RecordCountSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return pathOr(null, ['contentActivity', 'recordCount'], selectedCustomer);
});
export var PreviousRouteSelector = createSelector([RouteParams], function (params) {
  return params.previousRoute;
});
export var IsPreviousProductsRouteSelector = createSelector([RoutePreviousState], function (route) {
  return route.name.includes('index.customercare.customer.customerProducts.detail');
});
export var IsPreviousDevicesRouteSelector = createSelector([RoutePreviousState], function (route) {
  return route.name.includes('index.customercare.customer.devices');
});
export var ShowBackBannerSelector = createSelector([RecoverableContentActivitySelector], function (uiState) {
  return !!uiState.showBanner;
});
export var ShowRouteBackBannerSelector = createSelector([IsPreviousDevicesRouteSelector, IsPreviousProductsRouteSelector, ShowBackBannerSelector], function (isPreviousDevicesRoute, isPreviousProductsRoute, showBackBanner) {
  return showBackBanner && (isPreviousProductsRoute || isPreviousDevicesRoute);
});
export var ContentActivityErrorSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return path(['contentActivity', 'contentActivityError', 'translatedMessage'], selectedCustomer);
});
export var BackBannerTextSelector = createSelector([DeviceIdRouteParamSelector, DeviceNameRouteParamSelector, ProductIdRouteParamSelector, ProductNameSelector], function (deviceId, deviceName, productId, productName) {
  var bannerText = null;
  if (productId && productName) {
    bannerText = productName;
  }
  if (deviceId && deviceName) {
    bannerText = deviceName;
  }
  return i18n.translate(CustomerLocaleKeys.CONTENT_ACTIVITY.RETURN_TO, {
    bannerText: bannerText
  });
});
export var IsLoadingContentActivitySelector = createSelector([IsFetchingContentActivitySelector, MetadataCodeLoadedSelector(CODES.ProductLineOfBusinessDeliveryCapability)], function (isFetchingContentActivity, productLOBDeliveryCapabilityLoaded) {
  return !!(isFetchingContentActivity || !productLOBDeliveryCapabilityLoaded);
});
export var CurrentListHasContentActivitySelector = createSelector([CustomerContentActivityCollectionSelector], function (customerContentActivity) {
  return !!(customerContentActivity && customerContentActivity.length > 0);
});
export var HasFilteredContentActivitySelector = createSelector([CustomerContentActivityCollectionSelector, CurrentListHasContentActivitySelector], function (customerContentActivity, currentListHasContentActivity) {
  return !!(customerContentActivity && currentListHasContentActivity);
});
export var HasAnyContentActivitySelector = createSelector([AllContentActivityCollectionSelector], function (allContentActivity) {
  return !!(allContentActivity && allContentActivity.length > 0);
});
export var ShowListEmptyStateSelector = createSelector([HasAnyContentActivitySelector, CurrentListHasContentActivitySelector], function (hasAnyContentActivity, currentListHasContentActivity) {
  return hasAnyContentActivity && !currentListHasContentActivity;
});
export var ShouldShowBackBannerSelector = createSelector([ProductIdRouteParamSelector, DeviceIdRouteParamSelector, ShowRouteBackBannerSelector], function (productId, deviceId, showBackBanner) {
  return (productId || deviceId) && showBackBanner;
});
export var EmptyStateGlyphSelector = createSelector([ProductIdRouteParamSelector, DeviceIdRouteParamSelector], function (productId, deviceId) {
  return productId || deviceId ? GLYPH.SEARCH : GLYPH.NET_LINK;
});
export var EmptyStateMessageSelector = createSelector([HasAnyContentActivitySelector, ActiveIsSelectedSelector, ProductIdRouteParamSelector, ProductNameSelector, DeviceIdRouteParamSelector, DeviceNameRouteParamSelector], function (hasAnyContentActivity, activeIsSelected, productId, productName, deviceId, deviceName) {
  var type;
  var displayName = productId ? productName : deviceName;
  if (hasAnyContentActivity) {
    type = activeIsSelected ? i18n.translate(CustomerLocaleKeys.CONTENT_ACTIVITY.FILTER.ACTIVE).toLowerCase() : i18n.translate(CustomerLocaleKeys.CONTENT_ACTIVITY.FILTER.ARCHIVED).toLowerCase();
  }
  var emptyStateLocaleString = productId && productName || deviceId && deviceName ? CustomerLocaleKeys.CONTENT_ACTIVITY.NO_CONTENT_ACTIVITY.FILTERED : CustomerLocaleKeys.CONTENT_ACTIVITY.NO_CONTENT_ACTIVITY.GENERAL;
  return i18n.translate(emptyStateLocaleString, {
    type: type,
    displayName: displayName
  });
});